import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66dec19f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=66dec19f&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=66dec19f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dec19f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66dec19f')) {
      api.createRecord('66dec19f', component.options)
    } else {
      api.reload('66dec19f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=66dec19f&scoped=true", function () {
      api.rerender('66dec19f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/vabfilerc/index.vue"
export default component.exports